import { getCustomInspectionStandardTypSettings } from '../../../../../common/src/domain/customInspectionTypes/customInspectionTypeSettings';
import { InspectionStandardTypes } from '../../../../../common/src/enums/InspectionStandardTypes';

export function canImportFilter(inspectionStandardType: string): boolean {
    if (inspectionStandardType === InspectionStandardTypes.Free || inspectionStandardType === InspectionStandardTypes.Memo) {
        return true;
    }
    const customInspectionTypes = getCustomInspectionStandardTypSettings()
        .filter((i) => i.canBeImported)
        .map((i) => i.inspectionStandardType);

    return customInspectionTypes.includes(inspectionStandardType);
}
